<template>
  <div id="questionnaireItemManage">
    <b>評価項目管理画面（工事中）</b><br/><br/>

    <table class="table icon">
      <tr>
        <td>（工事中）評価項目を管理いただきます。</td>
      </tr>
    </table><br/>

    <button @click="$router.back(-1);" class="btn-mid" style="width:300px;">キャンセル</button><br/>
  </div>
</template>

<script>
  export default {
    name: "questionnaireItemManage",
    methods: {
    }
  };
</script>



// WEBPACK FOOTER //
// questionnaireItemManage.vue?7c515d39